import { combineReducers } from 'redux';

import dealer from './dealer';
import filters from './filters';
import group from './group';
import loading from './loading';

/**
 * @typedef {{
 *   dealer: import('./dealer').TagsDashboardDealerReducer,
 *   group: import('./group').TagsDashboardGroupReducer,
 *   filters: import('./filters').TagsFiltersReducer,
 *   loading: import('./loading').TagsDashboardLoadingReducer,
 * }} TagsUIDashboardReducer
 */

export default combineReducers({
  dealer,
  group,
  filters,
  loading,
});
